import { useState, type ReactNode } from 'react'
import { Icon } from '../../../components/icons/Icon'
import { Popover } from '../Popover'

export interface ColumnHeaderInfoProps {
  label: string
  content: ReactNode
}

/** The `Info` affordance next to a forward-looking column header (e.g. "Case", "Fiscal year"). */
export function ColumnHeaderInfo({ label, content }: ColumnHeaderInfoProps) {
  const [open, setOpen] = useState(false)
  return (
    <Popover
      label={label}
      open={open}
      onOpenChange={setOpen}
      width={220}
      triggerClassName="iw-icon-btn-sm"
      triggerContent={<Icon name="info" size={12} />}
    >
      <p style={{ margin: 0, fontSize: 'var(--iw-size-xs)', color: 'var(--iw-text-muted)' }}>{content}</p>
    </Popover>
  )
}
